import type { TailTelemetrySession } from "./simTelemetry";

/** Continuous SimConnect silence that asks whether the simulator crashed. */
export const SIM_CRASH_SILENCE_MS = 30_000;

export const SIM_CRASH_TITLE = "Did your simulator crash?";
export const SIM_CRASH_CONFIRM = "Yes";
export const SIM_CRASH_CANCEL = "No";
export const SIM_CRASH_BODY =
  "Yes treats the flight as if it never happened. Fuel, the aircraft, money, crew pay, duty, logs, and maintenance come back off.";

/** This desk process. A sample from before boot is a reconnect, not a sim crash. */
const DESK_BOOT_MS = Date.now();

export function deskBootMs(): number {
  return DESK_BOOT_MS;
}

/**
 * The flight actually left the ground on engine power and burned fuel.
 * APU, N1, and a silent fuel tank are not enough.
 */
export function sessionCrashGate(
  session: Pick<
    TailTelemetrySession,
    "tripId" | "closed" | "airborneSeen" | "combustionTrueSeen" | "fuelBurnedLb" | "fuelTrack"
  > | null | undefined,
): boolean {
  if (!session || session.closed || !session.tripId) return false;
  if (!session.airborneSeen || !session.combustionTrueSeen) return false;
  const waived = session.fuelTrack?.unlimited === true || session.fuelTrack?.dump === true;
  if (!waived && Math.round(session.fuelBurnedLb ?? 0) < 1) return false;
  return true;
}

/** Popup is due only for silence this process has already seen. */
export function simCrashPromptDue(input: {
  session: TailTelemetrySession | null | undefined;
  nowMs: number;
  deskBootMs?: number;
  dismissedLastAtUtc?: string | null;
}): boolean {
  const session = input.session;
  if (!sessionCrashGate(session) || !session) return false;
  const last = Date.parse(session.lastAtUtc);
  const boot = input.deskBootMs ?? DESK_BOOT_MS;
  if (!Number.isFinite(last) || last < boot) return false;
  if (input.nowMs - last < SIM_CRASH_SILENCE_MS) return false;
  if (input.dismissedLastAtUtc && input.dismissedLastAtUtc === session.lastAtUtc) return false;
  return true;
}
